import { CommonModule, NgClass } from '@angular/common';
import { Component, OnInit, Input, inject } from '@angular/core';

import { SelectComponent } from '../select.component';

@Component({
  selector: 'ux-select-header-user',
  templateUrl: './select-header-user.component.html',
  styleUrls: ['./select-header-user.component.less'],
  imports: [NgClass, CommonModule],
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectHeaderUserComponent implements OnInit {
  selectComponent = inject(SelectComponent);
  @Input() icon: string;
  @Input() placeholder: string;

  ngOnInit() {}
}
